// src/components/DashboardHome.js
import React, { useState, useEffect } from "react";
import Navbar from "../Header/Navbar2";
import AdminSidebar from "./AdminSidebar"; // Import your Navbar component
import SubscriptionChart from "./SubscriptionChart";
import ViewsChart from "./ViewCharts";
import BounceRateChart from "./BounceRateChart";
import { Link } from "react-router-dom";
import NewUsers from "./NewUsers";
import Overview from "./OverView";
import RecentActivity from "./RecentActivity";

import axios from "axios";
import { BASE_URL, security_key } from "../../global";

const DashboardHome = () => {
    const [loading, setLoading] = useState(false);
    const [memberActivity, setMemberActivity] = useState([]);
    const [totalSubscribers, setTotalSubscribers] = useState(0);
    const [totalViews, setTotalViews] = useState(0);

    useEffect(() => {
        getAdminMemberActivity();
        getAdminTotalSubscrbersAndViews();
    }, []);

    const getAdminMemberActivity = async () => {
        try {
            setLoading(true);

            const response = await axios.post(`${BASE_URL}API/apicall`, {
                security_key,
                mode: "getAdminMemberActivity",
                pk_user_key: sessionStorage.getItem("pk_user_key"),
            });

            const output = response.data;
            if (output.length > 0) {
                setMemberActivity(output);
            } else {
                console.error("Oops! Something went wrong.");
            }
        } catch (error) {
            console.error("Error adding article: " + error.message);
        } finally {
            setLoading(false);
        }
    };
    const getAdminTotalSubscrbersAndViews = async () => {
        try {
            setLoading(true);

            const response = await axios.post(`${BASE_URL}API/apicall`, {
                security_key,
                mode: "getAdminTotalSubscrbersAndViews",
            });

            const output = response.data;
            if (Object.keys(output).length > 0) {
                setTotalSubscribers(output.totalSubscribers);
                setTotalViews(output.totalViews);
            } else {
                console.error("Oops! Something went wrong.");
            }
        } catch (error) {
            console.error("Error adding article: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    const getTimeDifference = (row) => {
        if (row["MinuteDifference"] < 60) {
            return `${row["MinuteDifference"]} minute${row["MinuteDifference"] === 1 ? "" : "s"} ago`;
        }
        if (row["HourDifference"] < 24) {
            return `${row["HourDifference"]} hour${row["HourDifference"] === 1 ? "" : "s"} ago`;
        }
        if (row["DayDifference"] === 0 && row["HourDifference"] >= 24) {
            // If DayDifference is 0 but HourDifference is at least 24, it means it's within the same day
            return `${Math.floor(row["HourDifference"] / 24)} day${Math.floor(row["HourDifference"] / 24) === 1 ? "" : "s"} ago`;
        }
        return `${row["DayDifference"]} day${row["DayDifference"] === 1 ? "" : "s"} ago`;
    };
    return (
        <div className="dashboard-home">
            <div className="container">
                <Overview />
                <div className="row">
                    <div className="col-md-12 col-lg-8 bg-white mb-3">
                        <ul className="nav nav-pills gap-5 border-bottom" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link p-0 py-3 bg-white text-dark"
                                    id="pills-home-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-home"
                                    role="tab"
                                    aria-controls="pills-home"
                                    aria-selected="true"
                                >
                                    Subscribers
                                    <p className=" mb-0 fw-bold fs-5">{totalSubscribers}</p>
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link active p-0 py-3 bg-white text-dark"
                                    id="pills-profile-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-profile"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-profile"
                                    aria-selected="false"
                                >
                                    Total Views
                                    <p className=" mb-0 fw-bold fs-5">{totalViews}</p>
                                </button>
                            </li>
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade  " id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
                                <SubscriptionChart />
                            </div>
                            <div className="tab-pane fade show active" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
                                <ViewsChart />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-4 mb-3 px-md-0 px-lg-3 px-sm-0">
                        <NewUsers />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-lg-6 bg-white ps-0 mb-3">
                        <RecentActivity />
                    </div>
                    <div className="col-md-12 col-lg-6 mb-3 px-md-0 px-lg-3 px-sm-0">
                        <div className="bg-white py-3 h-100">
                            <h5 className="ms-3">Member Activity</h5>
                            <ul className="list-group">
                                {memberActivity.slice(0, 6).map((row, index) => {
                                    if (row.type_no == 1) {
                                        return (
                                            <li key={index} className="list-group-item">
                                                <strong>
                                                    {row.first_name} {row.last_name}
                                                </strong>{" "}
                                                {row.amount}$ payment requested
                                                <small className="text-muted float-end">{getTimeDifference(row)}</small>
                                            </li>
                                        );
                                    } else {
                                        return (
                                            <li key={index} className="list-group-item">
                                                <strong>
                                                    {row.first_name} {row.last_name}
                                                </strong>{" "}
                                                updated their profile details
                                                <small className="text-muted float-end">{getTimeDifference(row)}</small>
                                            </li>
                                        );
                                    }
                                })}
                                {/* <li className="list-group-item">
                                    <strong>Michael Brown</strong> updated their profile picture
                                    <small className="text-muted float-end">1 hour ago</small>
                                </li>
                                <li className="list-group-item">
                                    <strong>Linda Lee</strong> changed their membership plan
                                    <small className="text-muted float-end">4 hours ago</small>
                                </li>
                                <li className="list-group-item">
                                    <strong>Michael Brown</strong> updated their profile picture
                                    <small className="text-muted float-end">1 hour ago</small>
                                </li>
                                <li className="list-group-item">
                                    <strong>Emily Davis</strong> joined the group
                                    <small className="text-muted float-end">10 minutes ago</small>
                                </li>
                                <li className="list-group-item">
                                    <strong>Linda Lee</strong> changed their membership plan
                                    <small className="text-muted float-end">4 hours ago</small>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>
                {`
                    .nav-link.active {
                        border-bottom: 1px solid black;
                        border-radius: 0;
                    }
                `}
            </style>
        </div>
    );
};

export default DashboardHome;
